import Amplify from 'aws-amplify';
import awsconfig from './aws-exports';
Amplify.configure(awsconfig); // TODO: Find permanent home. Ensure it is declared only once.
